export default {"src":"/_next/static/media/Diploma-1.333e13c2.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};